export default __webpack_public_path__ + "static/media/phone.bd69838b.svg";